import React from 'react';
import DemoForm from 'components/Form/DemoForm';
import { getMarketoFormId } from 'utils/marketo';
import MarketoEmbedded from 'components/MarketoEmbedded';
import DynamicMarketoForm from 'components/Form/DynamicMarketoForm';

const MarketoForm = ({
  dataPosition,
  shadow,
  buttonLabel,
  marketoForm,
  formName,
  formType,
  closeModal,
  useEmbeddedForm,
  useCustomDqFlow,
  theme,
  ...otherProps
}) => {
  const marketoFormId = parseInt(getMarketoFormId(marketoForm));

  if (marketoForm) {
    formName = marketoForm.name;
  }

  return marketoFormId == 2175 ? (
    <DemoForm
      dataPosition={dataPosition}
      formType={formType || 'Demo Form'}
      backgroundColor="white"
      titleColor="#0B1A21"
      marketoFormId={marketoFormId}
      buttonLabel={buttonLabel}
      style={{ boxShadow: shadow ? '0px 30px 60px rgba(11, 26, 33, 0.15)' : 'none' }}
      {...otherProps}
    />
  ) : (
    <>
      {useEmbeddedForm === true ? (
        <MarketoEmbedded
          dataPosition={dataPosition}
          formType={formType}
          marketoFormId={marketoFormId}
          modalMode={false}
          closeModal={closeModal}
          theme={theme}
          {...otherProps}
        />
      ) : (
        <DynamicMarketoForm
          dataPosition={dataPosition}
          titleColor="black"
          marketoFormId={marketoFormId}
          buttonLabel={buttonLabel}
          formName={formName}
          formType={formType || 'Dynamic Marketo Form'}
          style={{ boxShadow: shadow ? '0px 30px 60px rgba(11, 26, 33, 0.15)' : 'none' }}
          useCustomDqFlow={useCustomDqFlow}
          {...otherProps}
        />
      )}
    </>
  );
};

export default MarketoForm;

MarketoForm.defaultProps = {
  shadow: true,
  width: '100%',
  buttonType: 'primary',
};
